
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { InnerMenuAccountComponent } from './inner-menu-account.component';
import { ProfileComponent } from './components/profile/profile.component';
import { RedirectComponent } from '../shared/components/redirect/redirect.component';
import { AuthGuard } from '../shared/auth.guard';

export const InnerMenuAccountRoutes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: InnerMenuAccountComponent,
        children: [
            {
                path: '',
                component: RedirectComponent,
            },
            {
                path: 'profile',
                component: ProfileComponent,
            }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(InnerMenuAccountRoutes)],
    exports: [RouterModule],
    providers: []
})
export class InnerMenuAccountRoutingModule { }
